export const signedInLogCallBack = (loggedInMethod) => {
  return {
    saveUserActivityLog: {
      action: 'signed_in',
      requestBody: { logged_in_method: loggedInMethod },
    },
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Login/utils.js